import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=5862f970&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=5862f970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862f970",
  null
  
)

export default component.exports